var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.606,
    height: 15.182,
    viewBox: "0 0 14.606 15.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31531",
    "data-name": "Rectangle 31531",
    width: 14.606,
    height: 15.182,
    transform: "translate(0 0)",
    fill: "#3c3c3b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile_icon",
    "data-name": "Profile icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12672",
    "data-name": "Group 12672",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38484",
    "data-name": "Path 38484",
    d: "M20.75,3.636A3.636,3.636,0,1,1,17.114,0,3.636,3.636,0,0,1,20.75,3.636",
    transform: "translate(-9.811 0)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38485",
    "data-name": "Path 38485",
    d: "M9.857,28.516a4.337,4.337,0,0,1-5.108,0A9.053,9.053,0,0,0,.057,34.387c-.22.752.225,1.553.853,1.553H13.7c.628,0,1.073-.8.853-1.553a9.052,9.052,0,0,0-4.692-5.871",
    transform: "translate(0 -20.758)",
    fill: "#3c3c3b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileicon);
export default __webpack_public_path__ + "static/media/Profile icon.64119685fce3379c5dff141c0bc9c6eb.svg";
export { ForwardRef as ReactComponent };